<template>

<app-page :locked="is.moving">

	<app-page-head :back="back" noun="item" :title="title" :count="list.length">

		<app-page-head-search v-model="searchText" :count="list.length" />

		<template v-if="$permission('full')">

			<app-page-head-action route="Item.Clone" icon="clone" tooltip="Clone item" />
			<app-page-head-action route="Item" :params="{ item: 'new' }" icon="create" tooltip="Add item" />
			<app-page-head-action v-if="$canDelete" v-on:click="onDeleteClick" :danger="true" :disabled="!selected.length" :count="selected.length" icon="delete" tooltip="Delete selected item(s)" />

		</template>

	</app-page-head>

	<app-page-content :is-loading="is.moving" :is-empty="!list.length" empty-message="No items found." :can-reorder="(isByGroup && $permission('edit')) ? order : false" v-on:reordered="onReordered">

		<com-item v-for="item in list" :key="item.id" :item="item" :can-order="isByGroup && $permission('edit')" :highlight="searchText" :selected="isSelected(item.id)" v-on:shiftclick="onSelectClick(item.id)" />

	</app-page-content>

	<app-page-foot />

</app-page>

</template>

<script>

import mixList from '@/mixin/list'

export default {

	mixins: [mixList],

	components: {
		'com-item': () => import('./items/Item')
	},

	data: function() {

		return {
			store: 'items'
		}

	},

	computed: {

		isByGroup: function() {

			return this.$route.meta.byGroup

		},

		group: function() {

			return (this.isByGroup) ? this.$store.getters['groups/find'](this.$route.params.group) : false

		},

		back: function() {

			return (this.isByGroup) ? 'Group' : false

		},

		title: function() {

			return (this.isByGroup) ? this.group.title : 'Items'

		},

		categories: function() {

			return this.$store.getters['categories']

		},

		groups: function() {

			return this.$store.getters['groups']

		}

	},

	methods: {

		search: function(value) {

			return this.$util.search(value.title, this.searchText) 

		},

		filter: function(item) {

			if (this.isByGroup) {

				return item.group === this.group.id

			} else {

				return true

			}

		},

		sort: function(item) {

			if (this.isByGroup) {

				return item.order

			} else {

				if (item.group) {

					var group = this.$_.findWhere(this.groups, {
						id: item.group
					})

					if(group) {

						return parseFloat(this.$_.findWhere(this.categories, {
							id: group.category
						}).order.toString() + '.' + this.$util.stringAsNumber(item.title).toString())

					}

				} else {

					return '1000'

				}

			}

		}

	}

}

</script>

<style scoped>

</style>
